<header id="header">
    <div class="container">
        <div class="header-barra">
            <a class="header-marca" routerLink="/" [attr.aria-label]="ente + ' – inicio'">
                <span class="header-escudo">
                    <img id="logoayuntamiento" src="{{url_escudo}}" alt="Escudo municipal">
                </span>
                <span class="header-text">
                    <span class="header-eyebrow">Sistema de pagos en línea</span>
                    <span class="header-titulo">{{ente}}</span>
                    <span class="header-sub">Administración {{administracion}}</span>
                </span>
            </a>

            <div class="header-derecha">
                <span class="header-seguro" title="Conexión cifrada y pagos con 3-D Secure">
                    <i class="fa-solid fa-lock" aria-hidden="true"></i>
                    <span>Pago seguro</span>
                </span>
                <span class="header-logo-admin">
                    <img id="logoadministracion" src="{{url_administracion}}" alt="Logo de la administración">
                </span>
            </div>
        </div>
    </div>
    <div class="header-accent-bar"></div>
</header>

<main>
    <router-outlet></router-outlet>
</main>

<footer id="footer">
    <div class="container">
        <div class="footer-grid">

            <!-- Marca -->
            <div class="footer-marca">
                <span class="footer-marca__logo">
                    <img id="logoadministracionfooter" src="{{url_footer}}" alt="Logo de la administración">
                </span>
                <div class="footer-marca__nombre">
                    <p class="footer-marca__eyebrow">Tesorería Municipal</p>
                    <p class="footer-marca__ente">{{ente}}</p>
                </div>
                <p class="footer-marca__texto">
                    Paga tu impuesto predial en línea de forma segura y obtén tu recibo oficial al instante.
                </p>
                <div class="footer-sellos" aria-label="Medios de pago">
                    <i class="fa-brands fa-cc-visa" aria-hidden="true"></i>
                    <i class="fa-brands fa-cc-mastercard" aria-hidden="true"></i>
                    <span><i class="fa-solid fa-shield-halved" aria-hidden="true"></i> 3-D Secure</span>
                </div>
            </div>

            <!-- Dirección -->
            <div class="footer-col">
                <h4>Dirección</h4>
                <address class="footer-direccion">
                    <span *ngFor="let direccion of direcciones">{{direccion}}</span>
                </address>
                <a class="footer-link footer-link--accion" *ngIf="direcciones?.length" [href]="urlMapa" target="_blank" rel="noopener">
                    <i class="fa-solid fa-location-dot" aria-hidden="true"></i> Ver en el mapa
                </a>
            </div>

            <!-- Contacto -->
            <div class="footer-col">
                <h4>Contacto</h4>
                <ul class="footer-lista">
                    <li *ngFor="let telefono of telefonos">
                        <a class="footer-link" [href]="'tel:' + telefono">
                            <i class="fa-solid fa-phone" aria-hidden="true"></i> {{telefono}}
                        </a>
                    </li>
                    <li *ngFor="let email of emails">
                        <a class="footer-link" [href]="'mailto:' + email">
                            <i class="fa-solid fa-envelope" aria-hidden="true"></i> {{email}}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Enlaces -->
            <div class="footer-col">
                <h4>Enlaces</h4>
                <ul class="footer-lista">
                    <li>
                        <a class="footer-link" routerLink="/">
                            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i> Consultar adeudo
                        </a>
                    </li>
                    <li *ngIf="url_aviso">
                        <a class="footer-link" [href]="url_aviso" target="_blank" rel="noopener">
                            <i class="fa-solid fa-file-shield" aria-hidden="true"></i> Aviso de privacidad
                        </a>
                    </li>
                </ul>
            </div>

        </div>

        <div class="footer-bottom">
            <span id="administracion">© {{anio}} {{ente}} · Administración {{administracion}}</span>
            <span class="footer-bottom__sistema">
                <i class="fa-solid fa-lock" aria-hidden="true"></i> Sistema de pagos en línea
            </span>
        </div>
    </div>
</footer>
